var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoResultsanalysis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34 17.9999C34 21.1644 33.0616 24.2579 31.3035 26.8891C29.5454 29.5202 27.0466 31.571 24.123 32.782C21.1993 33.993 17.9823 34.3099 14.8786 33.6925C11.7749 33.0751 8.92394 31.5513 6.6863 29.3136C4.44866 27.076 2.92481 24.2251 2.30744 21.1214C1.69008 18.0177 2.00693 14.8006 3.21794 11.877C4.42894 8.95337 6.4797 6.45451 9.11089 4.6964C11.7421 2.9383 14.8355 1.99992 18 1.99992V17.9999H34Z",
    fill: "#66B7FD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoResultsanalysis);
export default __webpack_public_path__ + "static/media/Ico_Results analysis.dddebb7055d31a7cb8879beefcf2d5cc.svg";
export { ForwardRef as ReactComponent };